export default __webpack_public_path__ + "_/videos/lootbox/video-default-894cd40be51fe154705981b94ca42a68b4cbae7584f7cb85a0e70fed5c0db0ad.webm";